import { render } from "./Sesame.vue?vue&type=template&id=0a0b128e"
import script from "./Sesame.vue?vue&type=script&lang=js"
export * from "./Sesame.vue?vue&type=script&lang=js"

import "./Sesame.vue?vue&type=style&index=0&id=0a0b128e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__